import React from 'react';
import PropTypes from 'prop-types';
import { PieChart, Pie, Cell, LabelList, Tooltip, Legend } from 'recharts';
import chroma from 'chroma-js';
import { Table, TableBody, TableRow, TableRowColumn } from 'material-ui/Table';
import { Card, CardTitle } from 'material-ui/Card';

const styles = {
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'nowrap'
  },
  half: {
    display: 'flex'
  },
  gridList: {
    display: 'flex',
    flexWrap: 'nowrap',
    overflowX: 'auto'
  },
  titleStyle: {
    color: 'rgb(0, 188, 212)'
  }
};

const colorsCache = {};
const getColor = (index, numberOfColors) => {
  if (!colorsCache[numberOfColors]) {
    colorsCache[numberOfColors] = chroma
      .scale('Spectral')
      .colors(numberOfColors);
  }
  return colorsCache[numberOfColors][index];
};

const DataTable = ({ data = [], total }) => {
  return (
    <Table>
      <TableBody displayRowCheckbox={false}>
        {data.map((dataItem, index) => (
          <TableRow key={`${dataItem.name}${dataItem.value}`}>
            <TableRowColumn
              width={30}
              style={{
                backgroundColor: getColor(index, data.length),
                padding: '0 5px'
              }}
            >
              &nbsp;
            </TableRowColumn>
            <TableRowColumn>{dataItem.name}</TableRowColumn>
            <TableRowColumn>{dataItem.value}</TableRowColumn>
          </TableRow>
        ))}
        {total && (
          <TableRow style={{ fontWeight: 'bold' }}>
            <TableRowColumn>&nbsp;</TableRowColumn>
            <TableRowColumn>{total.name}</TableRowColumn>
            <TableRowColumn>{total.value}</TableRowColumn>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};

DataTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  ).isRequired,
  total: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
};

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = props => {
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
    value,
    name
  } = props;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  if (percent) {
    return (
      <text
        x={x}
        y={y}
        fill="black"
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline="central"
      >
        <tspan alignmentBaseline="middle" fontSize="20">{`${(
          percent * 100
        ).toFixed(0)}%`}</tspan>
        {/* <tspan dx="-20" dy="10" fontSize="14">
          {value}
        </tspan>
        <tspan dx="-40" dy="20" fontSize="14">
          {name}
        </tspan> */}
      </text>
    );
  }
  return '';
};

const StatsSection = ({ title, data, total }) => (
  <Card>
    <CardTitle title={title} />
    <div style={styles.root}>
      <div style={styles.half}>
        <PieChart width={500} height={500}>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            labelLine={false}
            label={renderCustomizedLabel}
          >
            {data.map((entry, index) => (
              <Cell key={index} fill={getColor(index, data.length)} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </div>
      <div style={styles.half}>
        <DataTable data={data} total={total} />
      </div>
    </div>
  </Card>
);

StatsSection.propTypes = {
  data: DataTable.propTypes.data,
  total: DataTable.propTypes.total,
  title: PropTypes.string
};

export default StatsSection;



// WEBPACK FOOTER //
// ./src/components/StatsSection.js